module.exports = __webpack_public_path__ + "img/community.61f1b40c.png";